import { HeaderComponent } from 'src/scripts/sections/header'
import { ModalComponent } from '../modal'
import { $el, delay, transitionToPromise } from 'src/scripts/utils/utils'
import { replaceNodeChildren } from 'src/scripts/utils/dom'
import { isMobile } from 'src/scripts/utils/check-media'

const HEADER_SELECTOR = 'header-component'
const HEADER_WITH_POPUP_CLASS = 'shopify-section-header--with-cart-popup'
const SELECTOR_CONSENT_CHECKBOX = '.checkbox--consent'
const SELECTOR_CHECKOUT_BUTTON = 'button#checkout'
const SELECTOR_CONSENT_CHECKBOX_INPUT = '.checkbox--consent .checkbox__input'

export class CartNotificationPopup extends ModalComponent {
  wasHeaderHidden: boolean

  mountComponent(): void {
    super.mountComponent()
    this.addListener(this, 'change', this.handleConsentCheckboxChange)
  }

  unmountComponent(): void {
    super.unmountComponent()
    this.removeListener(this, 'change', this.handleConsentCheckboxChange)
  }

  handleConsentCheckboxChange = ({ target }) => {
    const consentCheckbox = target.closest(SELECTOR_CONSENT_CHECKBOX)

    if (consentCheckbox) {
      const checkoutButton = $el(SELECTOR_CHECKOUT_BUTTON, this)
      checkoutButton?.toggleAttribute('disabled', !target.checked)
    }
  }

  resetContextCheckbox = () => {
    const consentCheckboxInput = $el<HTMLInputElement>(
      SELECTOR_CONSENT_CHECKBOX_INPUT,
      this,
    )

    if (consentCheckboxInput) {
      const checkoutButton = $el(SELECTOR_CHECKOUT_BUTTON, this)
      checkoutButton?.toggleAttribute('disabled', true)
      consentCheckboxInput.checked = false
    }
  }

  purchaseHandler(html, parsedState): void {
    const header: HeaderComponent = $el(HEADER_SELECTOR)
    this.wasHeaderHidden = header.isHidden

    if (this.element) {
      const newNode = $el(`#CartNotificationPopupItem-${parsedState.id}`, html)
      const node = $el('[data-cart-notification-popup]', this.element)

      replaceNodeChildren(node, newNode)

      this.toggleMobileHeader(false).then(() => {
        this.show()

        delay(5000).then(() => {
          this.hide()
        })
      })

      this.emit('update-nodes', { node, parsedState })
    }
  }

  mount() {
    super.mount()
    this.resetContextCheckbox()
  }

  async hide() {
    await super.hide()

    await transitionToPromise(this)
    this.toggleMobileHeader(true)
  }

  toggleMobileHeader = async (isToShow: boolean): Promise<void> => {
    if (isMobile()) {
      const header: HeaderComponent = $el(HEADER_SELECTOR)

      header.parentElement.classList.toggle(HEADER_WITH_POPUP_CLASS, !isToShow)

      if (this.wasHeaderHidden) {
        header.setHidden(isToShow)
      }

      await delay(300)
    }
  }
}
